import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { UI } from '../../styles/tl5';

// "You're offline" — one of the reference's eight error states, and the
// only one that needs no server signal at all: the browser tells us.
//
// A strip under the header rather than a full-page card, because the
// reference's card replaces the page and losing your connection should
// not lose the form you were filling in. Booking already keeps its cart
// and member list in localStorage, so the copy's promise is true.

const OfflineBanner = () => {
  const [offline, setOffline] = useState(() => typeof navigator !== 'undefined' && navigator.onLine === false);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    // The flag can flip between first render and this effect running.
    setOffline(navigator.onLine === false);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        px: 2,
        py: 1.25,
        bgcolor: '#FFF4CC',
        color: '#8A6A00',
        fontFamily: UI,
        fontSize: 14,
        fontWeight: 700,
        textAlign: 'center',
      }}
    >
      <Box component="span" aria-hidden="true">↻</Box>
      You&rsquo;re offline. Check your connection — anything you&rsquo;ve entered is saved on this device.
      <Box
        component="button"
        type="button"
        onClick={() => window.location.reload()}
        sx={{
          border: 0,
          cursor: 'pointer',
          borderRadius: '999px',
          p: '6px 14px',
          font: 'inherit',
          fontWeight: 800,
          bgcolor: 'var(--tl-g9)',
          color: '#FFFFFF',
        }}
      >
        Try again
      </Box>
    </Box>
  );
};

export default OfflineBanner;
